import { createShouldForwardProp, props } from '@styled-system/should-forward-prop';

export const shouldForwardProp = (prop, defaultValidatorFn) =>
  createShouldForwardProp([...props, 'transform'])(prop) && defaultValidatorFn(prop);
